export default "__VITE_ASSET__CQ1G4ZJ9__"